import React, { FormEvent, useState, useEffect, useRef } from "react";
import styles from "./SearchPopupRadioLocal.module.scss";
import { ResetButton } from "components/buttons/resetButton/ResetButton";
import { getAllClassNames, setParams } from "helpers";
import { Close, Search } from "assets/icons";
import Button from "components/buttons/button/Button";
import { ArrowLeftPurple, ArrowUpPurple } from "assets/icons";
import strings from "assets/strings";
import { grad1, grad2, SERACH_DOCTORS_API } from "assets/constants";
import { AlertPopup } from "../alertPopup/AlertPopup";
import { settings } from "assets/settings";
import Popup from "../Popup";
import { KeyValuePair } from "types";
import { Loader } from "assets/images";

export type ISearchPopup = {
  title: string;
  subTitle?: string;
  placeholder?: string;
  attributeLocal?: string
  popupBubbles?: { value: string; label: string; }[];
  subbubble?: { value: string; label: string; }[];
  keyToNormalize: string;
  labelToNormalize: string;
  subFieldName?: string | undefined;
  serviceType?: string;
  queryParams?: KeyValuePair[];
  //filterBy: string;
  onSubmit: (vals: { value: string; label: string; hasSubField: boolean }[], subVals: string[], params: string) => void;
};


export const SearchPopupRadioLocal = ({
  title,
  subTitle,
  placeholder,
  attributeLocal,
  popupBubbles,
  subbubble,
  keyToNormalize,
  labelToNormalize,
  subFieldName,
  serviceType,
  queryParams,
  onSubmit,
}: ISearchPopup) => {
  const [selectOptions, setSelectOptions] = useState<Array<{ value: string; label: string; hasSubField: boolean; subOptions: { value: string; label: string; }[] }>>([]);
  const [query, setQuery] = useState("");  
  const [bubbles, setBubbles] = useState<Array<{ value: string; label: string; hasSubField: boolean }>>(popupBubbles as any[]);
  const [subBubbles, setSubBubbles] = useState<Array<{ value: string; label: string; hasSubField: boolean }>>(subbubble as any[]);
  const [mergedBubbles, setMergedBubles] = useState<Array<{ value: string; label: string; hasSubField: boolean }>>(popupBubbles as any[]);
  const [multiSelectParams, setMultiSelectParams] = useState<string[]>([]);
  const [toggeledItem, setToggeledItem] = useState<string | undefined>(bubbles[0]?.label || '');
  const [toggledSubItem, setToggledSubItem] = useState<number | undefined>(-1);
  const openerRef = useRef<HTMLButtonElement>(null);
  const [loading, setLoading] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  const isSelected = (value: any): boolean => {
    const values = mergedBubbles.map(item => item.label);
    return values.includes(value.label);
  }

  useEffect(() => {
    const popupIsShown = popupRef.current?.classList.contains('show');
    if (popupIsShown) {
      setTimeout(() => {
       // inputRef.current?.focus();
        inputRef.current?.blur();        
        closeButtonRef.current?.focus();
      }, 0);
    }
  }, [popupRef.current?.classList.contains('show')]);
  
  //add event listner to close popup when clicking escape key
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        handleToggleVisibility();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleToggleVisibility = () => {
    if (popupRef.current) {
      const isShowing = !popupRef.current.classList.contains('show');
      popupRef.current.classList.toggle('show');
      
      if (isShowing) {
        requestAnimationFrame(() => {
          closeButtonRef.current?.focus();
        });
      } else {
        requestAnimationFrame(() => {
          inputRef.current?.focus();
        });
      }
    }
  };

  const handleCloseKeyDown = (event: React.KeyboardEvent<SVGSVGElement>, item: { value: string; label: string; hasSubField?: boolean }) => {
    if (event.key === "Enter") {
      onSelect(item);
    }
  };

  const onSelect = (item: any, isSubField?: boolean) => {
    const tempParams: string[] = [];
    if (isSubField || !item.hasOwnProperty("hasSubField") || item.label === strings.searchDoctors.allSubMedicalFields) {
      let tempSubBubbles = [...subBubbles];
      if (item.label !== strings.searchDoctors.allSubMedicalFields) {
        //tempSubBubbles = tempSubBubbles.filter((item) => item.label !== strings.searchDoctors.allSubMedicalFields);
      }
      if (item.label === strings.searchDoctors.allSubMedicalFields) {
        //tempSubBubbles = tempSubBubbles.filter((item) => item.label === strings.searchDoctors.allSubMedicalFields);
      }
      if (item.hasOwnProperty("hasSubField")) {
        setSubBubbles([]);
      }
      else {
        const index = tempSubBubbles.findIndex((val) => val.label === item.label);
        if (index !== -1) tempSubBubbles.splice(index, 1);
        else tempSubBubbles.push(item);
        setSubBubbles(tempSubBubbles);
      }
    }

    else {
      const temp = [...bubbles];
      const index = temp.findIndex((bubble) => bubble.label === item.label);
      if (index !== -1) {
        setToggledSubItem(-1);
        setBubbles([]);
        setSubBubbles([])
      } else {
        setToggeledItem(item.label)
        tempParams.push(item.value);
        setBubbles([{ value: item.value, label: item.label, hasSubField: item.hasSubField }]);
        setSubBubbles([])
        setToggledSubItem(-1);
        //if (item.hasSubField) setSubBubbles([{ value: strings.searchDoctors.allSubMedicalFields, label: strings.searchDoctors.allSubMedicalFields, hasSubField: false }]);
      }
    }
    setMultiSelectParams(tempParams);
    //setToggeledItem(item.label)
    //setToggledSubItem(-1);
    //setQuery("");
  };

  const onContinue = () => {
    if (mergedBubbles.length === 0) {
      handleToggleVisibility();
      return;
    }
    const selectedSubBubbles = subBubbles.map((item) => item.label);
    onSubmit(mergedBubbles, selectedSubBubbles, multiSelectParams[0]);
  };

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleReset = (event: FormEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setQuery("");
  };

  useEffect(() => {
    const fetchOptions = async () => {
      setLoading(true);
      const response = await fetch(`https://${settings.searchApiUrl}${SERACH_DOCTORS_API}${serviceType ? `${serviceType}` : ''}${attributeLocal}?${setParams(queryParams)}`);
      const options: any[] = await response.json();
      if (options.length) {
        setLoading(false);       
        localStorage.setItem(`${attributeLocal}`, JSON.stringify(options));
        const normalizedOptions = options.map(item => {
          return {
            value: item[keyToNormalize],
            label: item[labelToNormalize],
            hasSubField: subFieldName && item[subFieldName]?.length > 0 ? true : false,
            subOptions: subFieldName && item[subFieldName]?.length > 0 ? [{ value: strings.searchDoctors.allSubMedicalFields, label: strings.searchDoctors.allSubMedicalFields }]
              .concat(item[subFieldName].map((subItem: any) => {
                return {
                  value: subItem,
                  label: subItem
                };
              })) : []
          };
        });        
        setSelectOptions(normalizedOptions);
      }
    }
    fetchOptions();
  }, [])

  useEffect(() => {
    setMergedBubles([...bubbles, ...(subBubbles ? subBubbles : [])]);
  }, [bubbles, subBubbles])

  return (
    <div className={getAllClassNames([ styles.container])}>
      <h3 className={styles.title}>{title}</h3>
      {subTitle && <p className={styles.subTitle}>{subTitle}</p>}
      <form
        action=""
        className={getAllClassNames([styles.form])}
        noValidate
        onSubmit={handleSubmit}
        onReset={handleReset}
      >
        <input
        ref={inputRef}
          aria-autocomplete="list"
          className="ais-SearchBox-input"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          placeholder={placeholder}
          spellCheck={false}
          maxLength={35}
          type="search"
          value={query}
          onChange={(e: any) => setQuery(e.target.value)}
        />
        {!query && <Search className={styles.searchIcon} />}
        <ResetButton hidden={query === undefined || query.length === 0} />
      </form>
      {loading && <div className={styles.popup}><img src={Loader} /></div>}
      <div className={styles.divList}>
        {mergedBubbles.length > 0 && (
          <div className={styles.divBubbles}>
            {mergedBubbles.map((item) => (
              <div key={item.value} className={styles.bubble}>
                <span className={styles.labelText}>{item.label}</span>
                <Close
                  aria-label={`${strings.globalStrings.remove} ${item.label}`}
                  onClick={() => onSelect(item, false)}
                  className={styles.closeIcon}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(event) => handleCloseKeyDown(event, item)}
                />
              </div>
            ))}
          </div>
        )}
        <div className={styles.list}>
          {selectOptions
            .filter((item) => typeof item.label === 'string' && item.label.toLowerCase().includes(query.toLowerCase()))
            .map((item, index) => (
              <>
                <div className={getAllClassNames([
                  styles.fieldsContainer,
                  toggledSubItem == index && styles.toggledItem
                ])}>
                  <label
                    key={item.value}
                    className={getAllClassNames([
                      "ais-RefinementList-label",
                      isSelected(item) && "ais-RefinementList-item--selected",
                      styles.label,
                    ])}
                  >
                    <input
                      className={getAllClassNames([
                        "ais-RefinementList-radio",
                        styles.radio,
                      ])}
                      type="radio"
                      value={item.value}
                      checked={isSelected(item)}
                      onChange={() => onSelect(item, false)}
                    />
                    <span
                      className={getAllClassNames([
                        "ais-RefinementList-labelText",
                        styles.labelText,
                      ])}
                    >
                      {item.label}
                    </span>
                  </label>
                  {item.hasSubField && toggeledItem == item.label && bubbles.length > 0 && <button type="button" onClick={() => { toggledSubItem == -1 ? setToggledSubItem(index) : setToggledSubItem(-1) }} aria-expanded={toggledSubItem ? 'false' : 'true'} className={styles.subFieldTitleWrapper}>
                    <span className={styles.subFieldTitle}>{strings.searchDoctors.selectSubMedicalField}</span>
                    {toggledSubItem == -1 ?
                      <ArrowLeftPurple
                        className={styles.iconArrow}
                      //onClick={() => setToggledSubItem(index)}
                      /> :
                      <ArrowUpPurple
                        className={styles.iconArrow}
                      // onClick={() => setToggledSubItem(-1)}
                      />
                    }
                  </button>}
                </div>
                {item.hasSubField && toggledSubItem == index ? <div className={styles.subFieldsContainer}/*style={{background: '#F6F1F6', paddingInlineStart:'1rem'}}*/>
                  <div className={styles.subFieldsTitle}>ניתן לבחור יותר מתת תחום אחד</div>
                  {item.subOptions.map((subItem) => (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <label
                        key={subItem.value}
                        className={getAllClassNames([
                          "ais-RefinementList-label",
                          isSelected(subItem) && "ais-RefinementList-item--selected",
                          styles.labelInner,
                        ])}
                      >
                        <input
                          className={getAllClassNames([
                            styles.radio,
                          ])}
                          type="checkbox"
                          value={subItem.value}
                          checked={isSelected(subItem)}
                          onChange={() => onSelect(subItem, true)}
                        />
                        <span
                          className={getAllClassNames([
                            "ais-RefinementList-labelText",
                            styles.labelText,
                          ])}
                        >
                          {subItem.value}
                        </span>
                      </label>
                    </div>
                  ))}
                </div> : null
                }
              </>
            ))}
        </div>
      </div>
      <div className={styles.viewBottom}>
        <Button
          ref={openerRef}
          onClick={onContinue}
          color1={grad1}
          color2={grad2}
          replaceClassName={styles.buttonContinue}
          text={strings.globalStrings.continue}
        />
      </div>
      {
        <Popup
          ref={popupRef}
          hideBackdrop
          onClose={() => handleToggleVisibility()}
          height={284}
          width={450}
          style={{ paddingBottom: '0px' }}
        >
          <AlertPopup
            title={strings.errorMessages.notice}
            subTitle={strings.globalStrings.selectItemFromList}
            showButton
            buttonText={strings.globalStrings.close}
            onClose={() => handleToggleVisibility()}
            closeButtonRef={closeButtonRef}
          ></AlertPopup>
        </Popup>
      }
    </div>
  );
};
